import React, { useState, useEffect } from "react";

const Parts = () => {
  return <div>Dijelovi</div>;
};

export default Parts;
